export const services = [
  {
    id: 1,
    title: 'Custom Web Apps & Portals',
    description: 'Tailored Software designed to boost your productivity and solve your unique challenges',
    features: [
      'Role-based access, audit trails, responsive UIs',
      'Secure forms, reports, exports'
    ],
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
  },
  {
    id: 2,
    title: 'Inventory, POS & Billing Systems',
    description: 'Access your data anytime, anywhere with reliable cloud solutions and backup plans.',
    features: [
      'Barcode-ready, printable receipts, multi-branch',
      'Sales, returns, and stock reconciliation'
    ],
    icon: 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'
  },
  {
    id: 3,
    title: 'Data Dashboards & Analytics',
    description: 'Make your business stand out online with stunning website and fast, secure hostings.',
    features: [
      'KPI snapshots, automated ETL, exportable insights',
      'Drilldowns, filters, scheduled reports'
    ],
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
  },
  {
    id: 4,
    title: 'Website Development & Hosting',
    description: 'Professional websites with reliable hosting and maintenance services',
    features: [
      'Custom website design and development',
      'Domain setup, SSL certificates, and hosting'
    ],
    icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9'
  },
  {
    id: 5,
    title: 'Portfolio & Business Websites',
    description: 'Showcase your work and grow your business with professional online presence',
    features: [
      'Portfolio galleries and project showcases',
      'Business websites with contact forms and SEO'
    ],
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
  },
  {
    id: 6,
    title: 'Database Design & Optimization',
    description: 'Comprehensive database solutions for performance and reliability',
    features: [
      'Indexing, performance tuning, migration, HA',
      'Backup/restore, access controls'
    ],
    icon: 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4'
  }
];
